<template>   
    <div class="impactScore-container" v-if="PILStickerData && isPILPage">
         <div class="impactScore-img">
              <img 
                   :src="PILStickerData.gradeImage ? PILStickerData.gradeImage : ''"
                   :data-src="PILStickerData.gradeImage ? PILStickerData.gradeImage : ''"
                   :alt="PILStickerData.gradeImageAlt ? `${PILStickerData.gradeImageAlt}-Grade-Score-Image` : projectScoreAlt"
                   class="product-env-impact-score-img lazyload"
                   ref="project-score-image"
              />
         </div>
         <div class="impactScore-des">
              <div class="impactScore-des__title"><span>{{  PILStickerData.scoreTextStatement}} : </span><span class="project-score">{{ PILStickerData.gradeValue }}</span></div>
              <button class="read-more__cta" @click="navigatePIL">{{  PILStickerData.readMoreTextPIL }} </button>
         </div>   
    </div>   
</template>   
<script>
import { mapState } from 'vuex';
import productDetailStore from '../../scripts/stores/productDetail/productDetail';

export default {
    name: 'product-env-impact-score',
    props: {},
    data() {
         return {
              projectScoreAlt: 'project-score-img-unavailable',
         };
    },
    computed: {
         ...mapState('productDetail', ['PILStickerData', 'isPILPage']),
    },
    beforeCreate() {
      !this.$store.state.productDetail && this.$store.registerModule('productDetail', productDetailStore);
    },
    methods: {
         navigatePIL(){
           window.eventBus.$emit('navigateToPIL')
         }
    }    
};
</script>
<style lang="scss" src="./product-env-impact-score.scss"></style>